import React from "react";
import { Button, Menu, type ButtonProps, type PopoverProps } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { useMenuState } from "../hooks";

export interface DropdownMenuProps {
	readonly label: React.ReactNode;
	/**
	 * The content of the dropdown menu. Should be a list of MUI `MenuItem` components.
	 */
	readonly children: React.ReactNode;
	readonly buttonProps?: Omit<ButtonProps, "onClick">;
	readonly popoverProps?: Omit<PopoverProps, "open">;
}

export const DropdownMenu: React.FC<DropdownMenuProps> = ({ label, children, buttonProps, popoverProps }) => {
	const { anchorEl, open, handleOpen, handleClose, handleMenuItemClick } = useMenuState();

	return (
		<>
			<Button
				onClick={handleOpen}
				{...buttonProps}
				endIcon={buttonProps?.endIcon ?? <KeyboardArrowDownIcon />}
				data-testid="dropdown-menu-button"
				sx={{
					"& .MuiButton-endIcon": {
						marginLeft: "auto",
					},
					...buttonProps?.sx,
				}}
			>
				{label}
			</Button>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				onClick={handleMenuItemClick}
				{...popoverProps}
				data-testid="dropdown-menu"
			>
				{children}
			</Menu>
		</>
	);
};
